import request from "./request";

//刷新token
export function refreshToken(params) {
  return request({
    url: "/cczhweb/refreshToken",
    params,
    method: "post",
    isToken: true,
  });
}

// 获取密码公钥
export function getPublicKey() {
  return request({
    url: "/cczhweb/publicKey",
    method: "get",
  });
}

// 获取手机号验证码
export function getCode(phone, vCode) {
  return request({
    url: `/cczhweb/sms/login/code/${phone}/${vCode}`,
    method: "get",
  });
}

// 获取手机号验证码
export function getRegisterCode(phone, vCode) {
  return request({
    url: `/cczhweb/sms/register/code/${phone}/${vCode}`,
    method: "get",
  });
}

// 通过token获取验证码
export function smsSend() {
  return request({
    url: "/cczhweb/sms/sendCode",
    method: "get",
    isToken: true,
  });
}

// 注册
export function register(data) {
  return request({
    url: "/cczhweb/user/register",
    method: "post",
    data,
  });
}

// 登录
export function login(data) {
  return request({
    url: "/cczhweb/login",
    method: "post",
    data,
  });
}

// 账户金额
export function getAmountInfo() {
  return request({
    url: "/cczhweb/user/account",
    method: "get",
    isToken: true,
  });
}

// 账户首页
export function getUserIndex() {
  return request({
    url: "/cczhweb/user/info",
    method: "get",
    isToken: true,
  });
}

// 个人资料
export function getMemberInfo() {
  return request({
    url: "/cczhweb/user/detail",
    method: "get",
    isToken: true,
  });
}

// 忘记密码账号校验
export function forgetPwdVerify(params) {
  return request({
    url: "/cczhweb/forgetPwd/verify",
    params,
    method: "get",
  });
}

// 获取修改密码短信
export function verifyCode(verifyCode) {
  return request({
    url: `/cczhweb/sms/verifyCode/${verifyCode}`,
    method: "get",
  });
}

// 获取修改密码短信
export function postVerifyCode(data) {
  return request({
    url: `/cczhweb/sms/verifyCode`,
    data,
    method: "post",
    isToken: true,
  });
}

//验证验证码
export function forgetPwdVerifySmsCode(params) {
  return request({
    url: "/cczhweb/forgetPwdVerifySmsCode",
    params: { ...params },
    method: "post",
  });
}

//忘记密码修改密码
export function forgetPwdChange(data) {
  return request({
    url: "/cczhweb/pwd/change",
    data,
    method: "post",
  });
}

// 账户首页
export function userInfo() {
  return request({
    url: "/cczhweb/user/info",
    method: "get",
    isToken: true,
  });
}

// 上传头像
export function uploadPicture(data) {
  return request({
    url: "/cczhweb/upload/picture",
    data,
    method: "post",
    isToken: true,
  });
}

// 个人资料修改
export function userEdit(data) {
  return request({
    url: "/cczhweb/user/edit",
    data,
    method: "post",
    isToken: true,
  });
}

// 我的认证信息
export function securityCenter() {
  return request({
    url: "/cczhweb/user/securityCenter",
    method: "get",
    isToken: true,
  });
}

// 身份认证保存
export function userIdentitySave(data) {
  return request({
    url: "/cczhweb/prove/userIdentity/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 修改密码
export function userPwdUpdate(data) {
  return request({
    url: "/cczhweb/user/pwd/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 设置邮箱
export function userEmailAdd(data) {
  return request({
    url: "/cczhweb/user/email/create",
    data,
    method: "post",
    isToken: true,
  });
}

// 修改邮箱
export function userEmailUpdate(data) {
  return request({
    url: "/cczhweb/user/email/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 邮箱认证
export function userVerifyEmail(params) {
  return request({
    url: "/cczhweb/prove/verifyEmail",
    params,
    method: "get",
    isToken: true,
  });
}

// 修改手机号
export function userMobileUpdate(data) {
  return request({
    url: "/cczhweb/user/mobile/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 我的认证
export function myCertification() {
  return request({
    url: "/cczhweb/prove/myCertification",
    method: "get",
    isToken: true,
  });
}

// 个人认证认证列表
export function userIdentityList(params) {
  return request({
    url: "/cczhweb/prove/userIdentity/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 企业认证保存
export function enterpriseIdentitySave(data) {
  return request({
    url: "/cczhweb/prove/enterpriseIdentity/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 个人认证删除
export function userIdentityDelete(data) {
  return request({
    url: `/cczhweb/prove/userIdentity/delete/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 企业认证
export function enterpriseIdentityList(params) {
  return request({
    url: "/cczhweb/prove/enterpriseIdentity/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 企业认证认证图片
export function enterpriseIdentityUpload(data) {
  return request({
    url: `/cczhweb/prove/enterpriseIdentity/img/upload`,
    data,
    method: "post",
    isToken: true,
  });
}

// 企业认证删除
export function enterpriseIdentityDelete(data) {
  return request({
    url: `/cczhweb/prove/enterpriseIdentity/delete/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 邮箱认证
export function certifiedEmailList(params) {
  return request({
    url: "/cczhweb/prove/certifiedEmail/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 邮箱删除
export function certifiedEmailDelete(data) {
  return request({
    url: `/cczhweb/prove/certifiedEmail/delete/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 重新发送邮箱认证
export function certifiedEmailSendEmail(data) {
  return request({
    url: `/cczhweb/prove/sendEmail`,
    params: { ...data },
    method: "post",
    isToken: true,
  });
}

// 登录日志
export function loginLogList(params) {
  return request({
    url: "/cczhweb/loginLog/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 充值接口
export function payRecharge(data) {
  return request({
    url: `/cczhweb/pay/recharge`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取银行卡列表
export function bankCardList(params) {
  return request({
    url: "/cczhweb/bankCard/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 添加银行卡
export function createBankCard(data) {
  return request({
    url: `/cczhweb/bankCard/createBankCard`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取银行卡名称
export function getBankName(params) {
  return request({
    url: "/cczhweb/bankCard/getBankName/" + params,
    params,
    method: "get",
    isToken: true,
  });
}

// 银行卡删除
export function bankCardDelete(data) {
  return request({
    url: `/cczhweb/bankCard/delete/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 获取提现比例
export function userLevel(params) {
  return request({
    url: "/cczhweb/user/level",
    params,
    method: "get",
    isToken: true,
  });
}

// 提现申请
export function withdraw(data) {
  return request({
    url: `/cczhweb/withdrawal/withdraw`,
    data,
    method: "post",
    isToken: true,
  });
}

// 提现记录
export function withdrawalPageList(params) {
  return request({
    url: "/cczhweb/withdrawal/pageList",
    params,
    method: "get",
    isToken: true,
  });
}

// 取消申请提现
export function cancelCashOut(withdrawalId) {
  return request({
    url: "/cczhweb/withdrawal/" + withdrawalId,
    method: "PATCH",
    isToken: true,
  });
}

// 财务类型
export function financeTypeList(params) {
  return request({
    url: "/cczhweb/user/financeType/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 资金明细
export function financeList(params) {
  return request({
    url: "/cczhweb/user/finance/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票列表
export function invoiceList(params) {
  return request({
    url: "/cczhweb/invoice/invoiceList",
    params,
    method: "get",
    isToken: true,
  });
}

// 取消发票申请
export function invoiceCancel(data) {
  return request({
    url: `/cczhweb/invoice/cancel`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取发票信息查询
export function invoiceInfoList(params) {
  return request({
    url: "/cczhweb/invoice/infoList",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息保存
export function invoiceInfoSave(data) {
  return request({
    url: `/cczhweb/invoice/info/save`,
    data,
    method: "post",
    isToken: true,
  });
}

// 发票信息单个查询
export function invoiceInfoDetail(params) {
  return request({
    url: "/cczhweb/invoice/infoDetail",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票类型
export function invoiceTypeList(params) {
  return request({
    url: "/cczhweb/invoice/typeList",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票数据
export function invoiceInvoiceAmountList(params) {
  return request({
    url: "/cczhweb/invoice/invoiceAmountList",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票总金额
export function invoiceTotalInvoiceAmount(params) {
  return request({
    url: "/cczhweb/invoice/totalInvoiceAmount",
    params,
    method: "get",
    isToken: true,
  });
}

// 默认发票
export function invoiceDefault(params) {
  return request({
    url: "/cczhweb/invoice/default",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息查询全部
export function invoiceInfoMore(params) {
  return request({
    url: "/cczhweb/invoice/infoMore",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息申请
export function applyMakeInvoice(data) {
  return request({
    url: `/cczhweb/invoice/applyMakeInvoice`,
    data,
    method: "post",
    isToken: true,
  });
}

// 发票信息根据ID查询
export function invoiceInvoiceDetail(params) {
  return request({
    url: "/cczhweb/invoice/invoiceDetail",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-列表
export function resolutionList(params) {
  return request({
    url: "/cczhweb/domain/resolution/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-启用记录
export function resolutionRecordStart(data) {
  return request({
    url: `/cczhweb/domain/resolution/record/start/${data}`,
    method: "post",
    isToken: true,
  });
}

// 域名解析-暂停记录
export function resolutionRecordPause(data) {
  return request({
    url: `/cczhweb/domain/resolution/record/pause/${data}`,
    method: "post",
    isToken: true,
  });
}

// 域名解析-删除记录
export function resolutionRecordRemove(data) {
  return request({
    url: `/cczhweb/domain/resolution/record/remove/`,
    data,
    method: "DELETE",
    isToken: true,
  });
}

// 域名解析-获取记录类型、线路
export function resolutionGetRoute(params) {
  return request({
    url: "/cczhweb/domain/resolution/getRoute",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-保存记录
export function resolutionSave(data) {
  return request({
    url: `/cczhweb/domain/resolution/save`,
    data,
    method: "post",
    isToken: true,
  });
}

// 域名解析-保存记录
export function resolutionModify(data) {
  return request({
    url: `/cczhweb/domain/resolution/record/modify`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取DNS-根据ID获取
export function domainDnsList(params) {
  return request({
    url: "/cczhweb/domain/dnsList",
    params,
    method: "get",
    isToken: true,
  });
}

// 设置DNS-保存记录
export function domainDnsCreate(data) {
  return request({
    url: `/cczhweb/domain/dns/create`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取DNS-dns日志
export function domainDnsLogList(params) {
  return request({
    url: "/cczhweb/domain/dnsLog/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取域名信息
export function domainDetail(params) {
  return request({
    url: "/cczhweb/domain/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取域名证书
export function getDownloadDomainPicById(params) {
  return request({
    url: "/cczhweb/domain/certificate/download",
    params,
    method: "get",
    responseType: "arraybuffer",
    isToken: true,
  });
}


// 站内信类型
export function mailSiteType() {
  return request(
    {
      url: "/cczhweb/messageTemplates/siteType",
      method: "get",
      isToken: true,
    },
  );
}

// 获取站内信列表
export function mailSiteList(data) {
  return request(
    {
      url: "/cczhweb/messageTemplates/siteList",
      method: "post",
      data,
      isToken: true,
    }
  );
}


// 站内信设置已读
export function mailSiteRead(data) {
  return request(
    {
      url: "/cczhweb/messageTemplates/siteRead",
      method: "post",
      data,
      isToken: true,
    }
  );
}



// 删除站内信
export function mialSiteDel(data) {
  return request(
    {
      url: "/cczhweb/messageTemplates/siteDel",
      method: "post",
      data,
      isToken: true,
    }
  );
}
